// Globals
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Modules
import { Header } from '@/modules/Layout';

// Components
import { SuggestedFaqTable } from '../../components';
import { StyledContainer } from './SuggestedFaqsContainerStyles';

// Helpers
import { getSuggestedFaqStatusOptions } from '../../helpers';
import { useGetSuggestedFaqs, useSuggestedFaqFilters } from '../../hooks';

const SuggestedFaqsContainer = () => {
  const { t } = useTranslation();
  const { filters, page, handleFilterChange, handlePageChange } = useSuggestedFaqFilters();
  const { suggestions, isLoading, pagination } = useGetSuggestedFaqs(filters, page);

  const statusOptions = useMemo(() => getSuggestedFaqStatusOptions(t), [t]);

  return (
    <>
      <Header title={t('menu_suggested_faq')} suptitle={t('menu_faqs')} description={t('suggested_faq_description')} />
      <StyledContainer>
        <SuggestedFaqTable
          data={suggestions}
          isLoading={isLoading}
          pagination={pagination}
          onPageChange={handlePageChange}
          filters={filters}
          onFilterChange={handleFilterChange}
          statusOptions={statusOptions}
        />
      </StyledContainer>
    </>
  );
};

export default SuggestedFaqsContainer;
